import React, { useState } from "react";
import { Switch } from "@headlessui/react";
import { ToggleSwitchProps } from "@/types/ui-kit/inputs";

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ title, description, onChange, value = false }) => {
  const [enabled, setEnabled] = useState<boolean>(value);

  const handleChanged = (value: boolean) => {
    onChange?.(value);
    setEnabled(value);
  };

  return (
    <>
      <div className={`${description ? "items-start" : "items-center"} flex justify-between pb-4`}>
        <div className={description && "flex max-w-[200px] flex-col md:max-w-[320px] lg:max-w-[180px]"}>
          <div className="font-condensed text-md font-light text-dark dark:text-white">{title}</div>
          <p className="font-sans text-xs tracking-[0.25px] text-dark text-dark-70 dark:text-white-70">{description}</p>
        </div>
        <Switch
          checked={enabled}
          onChange={handleChanged}
          className={`${
            enabled ? "bg-dark dark:bg-middle-light-turquoise" : "border border-gray-300 bg-white"
          } relative inline-flex h-[28px] w-[48px] items-center rounded-full transition-colors`}
        >
          <span
            className={`${
              enabled ? "translate-x-[24px]" : "translate-x-[4px] border border-dark"
            } inline-block h-[20px] w-[20px] transform rounded-full bg-white transition-transform`}
          />
        </Switch>
      </div>
    </>
  );
};
